<script>
export default {
    name: "IconMap"
}
</script>

<template>
    <svg class="" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1509_31125)">
            <path d="M1.99609 2.03613V19.2132L8.24649 21.8602V4.68331L1.99609 2.03613Z" fill="currentColor"/>
            <path d="M15.7656 2.14355V19.3206L22.0159 21.9677V4.79061L15.7656 2.14355Z" fill="currentColor"/>
            <path d="M9.09766 4.61524V21.7923L14.9316 19.3215V2.14453L9.09766 4.61524Z" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_1509_31125">
                <rect width="20.0014" height="20.0006" fill="white" transform="translate(2.01172 1.99805)"/>
            </clipPath>
        </defs>
    </svg>
</template>

<style scoped lang="scss">

</style>
